import type { FormSchema } from '@cli-types/core-engine/schema.js'
import type { DevModeIntegrationArtifact } from '@cli-types/next-adapter/generators.js'
import { buildFormDevModeLifecycleHooks } from './build-form-dev-mode-lifecycle-hooks.js'
import { buildFormDevModeSnippets } from './build-form-dev-mode-snippets.js'
import { createDevModeIntegrationArtifact } from './create-dev-mode-integration-artifact.js'
export function buildFormDevModeIntegration(
  schema: FormSchema,
  adminDir: string,
  actionImportPath: string,
  adminImportAlias?: string
): DevModeIntegrationArtifact {
  return createDevModeIntegrationArtifact(
    schema,
    'form',
    adminDir,
    buildFormDevModeSnippets(schema, actionImportPath, adminImportAlias),
    buildFormDevModeLifecycleHooks(schema, adminImportAlias),
    adminImportAlias
  )
}
